import { useEffect } from 'react';

/**
 * 모달/툴팁이 열릴 때 body 스크롤을 잠그고,
 * 스크롤바 너비만큼 paddingRight를 추가하여 레이아웃 시프트를 방지한다.
 *
 * @param {boolean} isLocked - true이면 스크롤 잠금
 */
export function useBodyScrollLock(isLocked) {
  useEffect(() => {
    if (isLocked) {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }

    return () => {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    };
  }, [isLocked]);
}
